import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

import { reactive, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TableCell',
  props: {
    toolTipValue: { default: '' },
    textAlign: { default: 'left' },
    isHighlighted: { type: Boolean }
  },
  emits: ["onClick"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "cb7f1b5e": (_ctx.textAlign)
}))

const isEllipsis = ref(false);

const props = __props;

const emits = __emit;

/**
 * テキストにマウスオーバーしたときに、テキストが省略されているかどうかを判定する
 * @param e - イベント
 */
const mouseoverTextLabel = (e: MouseEvent) => {
  const { target } = e;
  if (!(target instanceof HTMLElement)) return;
  isEllipsis.value = target.offsetWidth < target.scrollWidth;
};

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (isEllipsis.value)
    ? _withDirectives((_openBlock(), _createElementBlock("td", {
        key: 0,
        class: _normalizeClass(["body-cell font-normal truncate", { 'body-cell--highlighted': props.isHighlighted }]),
        onClick: _cache[0] || (_cache[0] = () => emits('onClick')),
        onMouseover: mouseoverTextLabel
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 34)), [
        [
          _directive_tooltip,
          props.toolTipValue,
          void 0,
          { bottom: true }
        ]
      ])
    : (_openBlock(), _createElementBlock("td", {
        key: 1,
        class: _normalizeClass(["body-cell font-normal truncate", { 'body-cell--highlighted': props.isHighlighted }]),
        onClick: _cache[1] || (_cache[1] = () => emits('onClick')),
        onMouseover: mouseoverTextLabel
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 34))
}
}

})